/**
 * The user's plan, on demo data until the server tells it (docs/tasks/figma-navigation-multiplayer, В2): `?tier=free|pro|
 * proplus|proplusplus` picks it, Free otherwise.
 */
export type Tier = 'free' | 'pro' | 'proPlus' | 'proPlusPlus';
export type PaidTier = Exclude<Tier, 'free'>;
export type ExportFormat = 'image' | 'stats' | 'pdf' | 'shoppingList' | 'dwg' | 'max' | 'crm';

const TIERS: readonly Tier[] = ['free', 'pro', 'proPlus', 'proPlusPlus'];
const REQUIRED: Record<ExportFormat, Tier> = { image: 'free', stats: 'free', pdf: 'free', shoppingList: 'free', dwg: 'proPlus', max: 'proPlusPlus', crm: 'proPlusPlus' };
/** The plans' names, as the app prints them in every language. */
export const TIER_NAMES: Record<Tier, string> = { free: 'Free', pro: 'PRO', proPlus: 'PRO+', proPlusPlus: 'PRO++' };

export const requiredTier = (format: ExportFormat): Tier => REQUIRED[format];
export const allows = (tier: Tier, format: ExportFormat): boolean => TIERS.indexOf(tier) >= TIERS.indexOf(REQUIRED[format]);
/** The plan the Upgrade banner offers; none above the top one. */
export const nextTier = (tier: Tier): PaidTier | null => (TIERS[TIERS.indexOf(tier) + 1] as PaidTier | undefined) ?? null;

export function tierFromQuery(search: string): Tier {
  const asked = new URLSearchParams(search).get('tier')?.toLowerCase();
  return TIERS.find(tier => tier.toLowerCase() === asked) ?? 'free';
}
export const DEMO_TIER: Tier = typeof location === 'undefined' ? 'free' : tierFromQuery(location.search);
